module.exports = __webpack_public_path__ + "img/orange_088.eb4ada75.png";